import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsBandcampComponent } from './simple-icons-bandcamp.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsBandcampComponent ],
    exports:      [ SimpleIconsBandcampComponent ],
    bootstrap:    []
})
export class SimpleIconsBandcampModule {}
